import { useCallback, useEffect, useMemo, useState } from "react";
import Styles from "./styles.module.scss";
import SearchBar from "@Atom/SearchBar";
import JobSeekersCard from "@Molecule/JobSeekersCard";
import Images from "@Theme/Images";
import ModalWrapper from "@Atom/ModalWrapper";
import DetailModal from "./DetailModal";
import { useNavigate } from "react-router-dom";
import { getHistoryProfile } from "@Services/home";
import { useDebounce } from "@Hooks/useDebounce";
import moment from "moment";
import "moment/locale/id"; // Biar bulan & hari pakai Bahasa Indonesia
import { getStatus } from "@Helpers/getStatusRecruitment";

export default function PermataWorkHistory() {
  const [search, setSearch] = useState("");
  const [tab, setTab] = useState({
    id: 1,
    name: "Semua Lamaran",
    code: "All",
  });

  const [showDetail, setShowDetail] = useState(null);
  const navigate = useNavigate();

  const listFilter = useMemo(() => {
    return [
      {
        id: 1,
        name: "Semua Lamaran",
        code: "All",
      },
      {
        id: 2,
        name: "Screening",
        code: "Screening",
      },
      {
        id: 3,
        name: "Interview",
        code: "Interview",
      },
      {
        id: 4,
        name: "Penawaran Kerja",
        code: "Offering",
      },
      {
        id: 5,
        name: "TTD Kontrak",
        code: "Signing",
      },
      {
        id: 6,
        name: "Diterima Bekerja",
        code: "Joined",
      },
      {
        id: 7,
        name: "Lamaran Tidak Lanjut",
        code: "Declined",
      },
    ];
  }, []);

  const [loading, setLoading] = useState(false);
  const [list, setList] = useState(null);

  const debounceSearch = useDebounce(search, 300);

  const refetchHistory = useCallback(async () => {
    try {
      setLoading(true);

      const response = await getHistoryProfile(
        tab?.code || "",
        debounceSearch || ""
      );
      setList(response?.response);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }, [tab, debounceSearch]);

  useEffect(() => {
    refetchHistory();
  }, [refetchHistory]);

  const getType = useCallback(
    (item) => {
      let status = "-";
      if (
        getStatus(item) === "HOLD" ||
        getStatus(item) === "CONTRACTED" ||
        getStatus(item) === "Menolak Undangan HR" ||
        getStatus(item) === "Tidak Lolos Interview HR" ||
        getStatus(item) === "Tidak Hadir Interview HR" ||
        getStatus(item) === "Menolak Undangan User" ||
        getStatus(item) === "Tidak Lolos Interview User" ||
        getStatus(item) === "Penawaran Offering Ditolak" ||
        getStatus(item) === "CANCELLED"
      ) {
        status = "Lamaran Tidak Dilanjutkan";
      } else if (getStatus(item) === "Belum Diundang HR") {
        status = "Dalam Proses Screening";
      } else if (
        getStatus(item) === "Diundang HR" ||
        getStatus(item) === "Req. Reschedule Interview HR" ||
        getStatus(item) === "Butuh Penilaian HR" ||
        getStatus(item) === "Belum Diundang User"
      ) {
        status = "Proses Interview HR";
      } else if (
        getStatus(item) === "Diundang User" ||
        getStatus(item) === "Belum Kirim Rekomendasi" ||
        getStatus(item) === "Dikirim Rekomendasi ke User" ||
        getStatus(item) === "Belum Dikirim Offering"
      ) {
        status = "Proses Interview User";
      } else if (
        getStatus(item) === "Dikirim Offering" ||
        getStatus(item) === "Menunggu Verifikasi Pertama" ||
        getStatus(item) === "Perbaikan Data Offering" ||
        getStatus(item) === "Belum Generate" ||
        getStatus(item) === "Perbaikan Genetate Kontrak" ||
        getStatus(item) === "Menunggu Approval BM"
      ) {
        status = "Penawaran Kerja";
      } else if (
        getStatus(item) === "TTD Kontrak" ||
        getStatus(item) === "Menunggu Verifikasi Kedua" ||
        getStatus(item) === "Perbaikan TTD Kontrak" ||
        getStatus(item) === "Gagal Inject"
      ) {
        status = "Tanda Tangan Kontrak";
      } else if (getStatus(item) === "IOS SUCCESS") {
        status = "Diterima Bekerja";
      }

      return status;
    },
    [getStatus]
  );

  const data = useMemo(() => {
    return loading
      ? Array.from({ length: 3 }, (_, idx) => idx + 1)
      : list?.data?.length > 0
      ? list?.data?.map((el, idx) => {
          return {
            id: el?.id,
            name: el?.ExpectedPosition?.name,
            experience: el?.jobPosting?.experience,
            workType: el?.jobPosting?.workType,
            contractType: el?.jobPosting?.contractType,
            workMethod: el?.jobPosting?.workMethod,
            img: Images.PERAMATA_LOGO_CICRLE,
            client: el?.ExpectedPosition?.OrderScheme?.Client?.name,
            location: el?.ExpectedPosition?.City?.name,
            salary: el?.jobPosting?.salary,
            createdAt: el?.createdAt
              ? moment(new Date(el?.createdAt))?.format("D MMMM YYYY, HH:mm")
              : null,
            status: getType(el),
            isRevision:
              getStatus(el) === "Perbaikan Data Offering"
                ? "Harap lakukan perbaikan data diri"
                : getStatus(el) === "Perbaikan TTD Kontrak"
                ? "Harap lakukan perbaikan TTD pada kontrak"
                : "",

            isShowButton:
              getStatus(el) === "TTD Kontrak"
                ? "Tanda Tangan Kontrak"
                : getStatus(el) === "Dikirim Offering"
                ? "Lihat Penawaran Kerja"
                : getStatus(el) === "Diundang HR" ||
                  getStatus(el) === "Diundang User"
                ? "Buka Link Interview"
                : getStatus(el) === "Perbaikan Data Offering"
                ? "Perbaikan Data"
                : getStatus(el) === "Perbaikan TTD Kontrak"
                ? "Perbaiki Tanda Tangan Kontrak"
                : "",

            websiteCompany: null,
            linkInterview:
              getStatus(el) === "TTD Kontrak" ||
              getStatus(el) === "Perbaikan TTD Kontrak"
                ? el?.candidateLink?.contract
                : getStatus(el) === "Dikirim Offering" ||
                  getStatus(el) === "Perbaikan Data Offering"
                ? el?.candidateLink?.offering
                : getStatus(el) === "Diundang HR"
                ? el?.candidateLink?.interviewRO
                : getStatus(el) === "Diundang User"
                ? el?.candidateLink?.interviewClient
                : "",
          };
        })
      : [];
  }, [loading, list, getType, getStatus]);

  useEffect(() => {
    if (showDetail) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.removeProperty("overflow");
    }
  }, [showDetail]);

  return (
    <div className={Styles.right}>
      <div className={Styles.header}>
        <div className={Styles.left}>
          <span className={Styles.title}>Pekerjaan Dilamar</span>
          <span className={Styles.total}>{list?.totalData || 0}</span>
        </div>

        <div className={Styles.rightHeader}>
          <SearchBar
            value={search}
            placeholder={"Cari nama pekerjaan"}
            onChange={(e) => setSearch(e?.target?.value)}
          />
        </div>
      </div>

      <div className={Styles.content}>
        <div className={Styles.tabOptionsBox}>
          <div className={Styles.options}>
            {listFilter?.map((el, idx) => {
              return (
                <div
                  className={`${Styles.tab} ${
                    tab?.name === el?.name && Styles.active
                  }`}
                  key={idx}
                  onClick={() => setTab(el)}
                >
                  {el?.name}
                </div>
              );
            })}
          </div>
        </div>

        {data?.length > 0 ? (
          <div className={Styles.listBox}>
            {data?.map((el, idx) => {
              return (
                <JobSeekersCard
                  key={idx}
                  data={el}
                  isHistory
                  setShowDetail={() => setShowDetail(el)}
                  loading={loading}
                />
              );
            })}
          </div>
        ) : (
          <div className={Styles.emptyHandler}>
            <div className={Styles.images}>
              <img src={Images.BAG} alt="" />
            </div>

            <span className={Styles.spanEmpty}>
              Belum Ada Pekerjaan Yang Kamu Lamar
            </span>

            <button
              onClick={() => {
                navigate(`/job-seeker`);
              }}
            >
              Mulai Cari Loker
            </button>
          </div>
        )}
      </div>

      {showDetail && (
        <ModalWrapper
          show={showDetail}
          handleClose={() => setShowDetail(null)}
          isLandingPage
        >
          <DetailModal
            handleClose={() => setShowDetail(null)}
            showDetail={showDetail}
          />
        </ModalWrapper>
      )}
    </div>
  );
}
